import { ReactElement } from "react";
import { useAuth } from "../../contexts/AuthContext";

import { Stack, Typography } from "@mui/material";
import FolderCopyIcon from "@mui/icons-material/FolderCopy";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import { DashboardIcon } from "../../assets/svgs/DashboardIcon";
import { UsersIcon } from "../../assets/svgs/UsersIcon";
import { CubsIcon } from "../../assets/svgs/CubsIcon";
import { ProfileInfo } from "./ProfileInfo";
import { useLocation } from "react-router-dom";
import { Link } from "../global/Link";
import { ClientIcon } from "../../assets/svgs/ClientIcon";
import { CategoryIcon } from "../../assets/svgs/CategoryIcon";
import { AssetRegisterLogo } from "../../assets/svgs/AssetRegisterLogo";
import { TagIcon } from "../../assets/svgs/TagIcon";
import SettingsIcon from "@mui/icons-material/Settings";
import PersonIcon from "@mui/icons-material/Person";
import EpwinLogo from "../../assets/images/epwin.png";

type SidebarMenuItemType = {
  name: string;
  icon: ReactElement;
  selectedIcon: ReactElement;
  link: string;
  allowedRoles: number[];
};

const sidebarMenuItems: SidebarMenuItemType[] = [
  {
    name: "Dashboard",
    icon: <DashboardIcon color="#4B5851" />,
    selectedIcon: <DashboardIcon color="#FFFFFF" />,
    link: "/",
    allowedRoles: [0, 1, 2, 3], // all roles
  },
  {
    name: "Users",
    icon: <PersonIcon sx={{ color: "#4B5851" }} />,
    selectedIcon: <PersonIcon sx={{ color: "#ffffff" }} />,
    link: "/users",
    allowedRoles: [0, 2], // Admin or can manage users
  },
  {
    name: "Settings",
    icon: <SettingsIcon sx={{ color: "#4B5851" }} />,
    selectedIcon: <SettingsIcon sx={{ color: "#FFFFFF" }} />,
    link: "/settings",
    allowedRoles: [3], // Only price editors
  },
];

export const Sidebar = () => {
  const location = useLocation();
  const { user } = useAuth();

  return (
    <Stack
      className="sidebar"
      width="250px"
      minWidth="250px"
      height="100vh"
      borderRight="1px solid #DCDCE0">
      <Stack mt={4} alignItems="center" justifyContent="center">
        <Link to="/" style={{ textDecoration: "none" }}>
          <img
            src={EpwinLogo}
            style={{
              width: "210px",
            }}
          />
        </Link>
      </Stack>
      <Stack mt={2}>
        <ProfileInfo />
        {sidebarMenuItems
          .filter(
            item =>
              user?.roles?.some((role: number) =>
                item.allowedRoles.includes(role),
              ) || item.name == "Dashboard",
          )
          .map((item: SidebarMenuItemType, index: number) => {
            const isSelected =
              item.link === "/"
                ? item.link === location.pathname
                : location.pathname.startsWith(item.link);

            return (
              <Link
                className="sidebar-item"
                key={index}
                to={item.link}
                style={{
                  cursor: "pointer",
                  textDecoration: "none",
                  background: isSelected ? "#3E4049" : "#FFFFFF",
                  display: "block",
                  color: isSelected ? "#FFFFFF" : "#4B5851",
                  padding: "12px 16px",
                }}>
                <Stack flexDirection="row" alignItems="center">
                  <span style={{ minWidth: "25px", textAlign: "center" }}>
                    {isSelected ? item.selectedIcon : item.icon}
                  </span>
                  <Typography color={isSelected ? "#FFFFFF" : "#4B5851"} ml={1}>
                    {item.name}
                  </Typography>
                </Stack>
              </Link>
            );
          })}
      </Stack>
    </Stack>
  );
};
